<template>
  <!--  第三方账号-->
  <div class="app-auth">
    <a-row class="list-box" type="flex">
      <a-col class="list-item" v-for="(item, index) of thirdAccountList.list" :key="index" v-show="!(item.title === '华为' && item.status === false)">
        <p class="title">
          <span class="title-text">{{item.title}}</span>
          <img class="icon" :src="item.icon" alt="">
        </p>
        <p class="value">{{item.valuePrefix}}{{item.nickName}}</p>
        <p class=re-bind @click="openModal(item, index)">
          {{ item.handle }}<img class="icon" src="../../../assets/images/web/rightarrow.png" alt="">
        </p>
      </a-col>
    </a-row>

    <!--统一安全验证的弹窗-->
    <safeVerify ref="safeCheck" @handleOperate="handleOperate"/>

    <!--解除绑定的弹窗-->
    <a-modal
      :dialogStyle="{width: '480px'}"
      :visible="visible"
      @cancel="visible=false"
      @ok="visible = false"
      :destroyOnClose="true"
      :centered="true"
      :footer="null"
    >
      <div class="icon-contai">
        <div class="icon-box">
          <img class="logo" src="../../../assets/images/unbind.svg" alt="">
        </div>
      </div>
      <h3 class="modal-title">确认要解除{{ (currentUnbindItem && currentUnbindItem.title) || '微信' }}绑定？</h3>
      <p class="tip">解除{{ (currentUnbindItem && currentUnbindItem.title) || '微信' }}绑定后将无法继续使用{{ (currentUnbindItem && currentUnbindItem.title) || '微信' }}快速登录。</p>
      <div class="auth-btns">
        <a-button @click="visible = false">关闭</a-button>
        <a-button @click="unbind">解除绑定</a-button>
      </div>
    </a-modal>

    <!--绑定微信的弹窗-->
    <a-modal
      class="bind-wechat-modal"
      :visible="wechatQRVisible"
      @cancel="wechatQRVisible=false"
      :destroyOnClose="true"
      :centered="true"
      :closable="false"
      :footer="null"
    >
      <div id="login_container"></div>
    </a-modal>
  </div>
</template>

<script setup>
import { onBeforeMount, reactive, toRaw, computed, ref, nextTick } from 'vue';
import { GET, POST } from '@/packge/http';
import { message } from 'ant-design-vue';
import safeVerify from '@/components/safeVerify';
import { useRoute } from 'vue-router';
import { APP_ID, APP_SECRET } from '@/utils/constant';
import store from '@/store';
import { getBingInfo, thirdAccountList, visible, unbind, safeCheck, openModal, currentUnbindItem } from '@/utils/setup/thirdAccount';
import Common from '@/utils/common';

let wechatInfo = reactive({});
const route = useRoute();
const wxCode = route.query.code;
if (wxCode) { // 微信网站授权的code
  getWXInfo(wxCode);
}

let wechatQRVisible = ref(false);
function handleOperate (item) {
  console.log('web 第三方', item);
  if (item.status === true) {
    visible.value = true;
  } else {
    wechatQRVisible.value = true;
    nextTick(() => {
      Common.WXLogin();
    });
  }
}

/** 获取微信信息 */
function getWXInfo (code) {
  GET({
    url: '/account/wxCallback',
    params: {
      code: code,
      state: `${APP_ID}-${APP_SECRET}`
    }
  }).then(({ data }) => {
    wechatInfo = data;
    bindWechat();
  });
}
/** 绑定微信 */
function bindWechat () {
  const userId = computed(() => store.state.userInfo.uid);

  POST({
    url: '/account/web/bindWx',
    params: { userId: userId.value, ssoType: 'weixin_app', ...wechatInfo }
  }).then(({ data }) => {
    message.success('绑定成功');
    getBingInfo();
  });
}

onBeforeMount(() => {
  getBingInfo();
});
</script>

<style lang="scss" scoped>
.icon-contai {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  .icon-box {
    width: 72px;
    height: 72px;
    border-radius: 60px;
    background: linear-gradient(180deg, rgba(248, 165, 41, 1) 0%, rgba(255, 154, 36, 1) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.modal-title {
  margin-top: 32px;
  text-align: center;
  color: rgba(43, 54, 74, 1);
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
}
.tip {
  text-align: center;
  margin-top: 8px;
  color: rgba(134, 143, 156, 1);
  font-size: 14px;
  line-height: 18px;
}

</style>

<style lang="scss">
.ant-modal-body {
}
.auth-btns {
  margin-top: 32px;
  display: flex;
  .ant-btn {
    width: 196px;
    height: 44px;
    border: 1px solid rgba(233, 237, 243, 1);
    border-radius: 0;
    color: rgba(43, 54, 74, 1);
    font-family: PingFang SC;
    font-size: 14px;
  }
  .ant-btn:nth-child(1) {
    margin-right: 24px;
  }
  .ant-btn:nth-child(2) {
    color: rgb(250, 84, 94);
  }
}
</style>
